import { ContentItemWithImageProps } from "~/components/ContentItemWithImage";

export type SupportedVerticalLayouts =
  | VerticalLayoutTypeEnum.FourColumn
  | VerticalLayoutTypeEnum.Grid
  | VerticalLayoutTypeEnum.GroupOf3;

export enum VerticalLayoutTypeEnum {
  GroupOf3 = "groupOf3",
  Grid = "grid",
  FourColumn = "fourColumn",
}

export type GroupOf3Type = {
  layoutStyle: "groupOf3";
  displayPrimaryTag: boolean;
  displayMetadata: boolean;
  displayDate: boolean;
  title?: string | undefined;
  posts: ContentItemWithImageProps[];
};

export type FourColumnType = {
  layoutStyle: "fourColumn";
  displayPrimaryTag: boolean;
  displayMetadata: boolean;
  displayDate: boolean;
  title?: string | undefined;
  posts: ContentItemWithImageProps[];
};

export type GridComponentType = {
  layoutStyle: "grid";
  displayPrimaryTag: boolean;
  displayMetadata: boolean;
  displayDate: boolean;
  title?: string | undefined;
  groupLeft: {
    title?: string | undefined;
    posts: ContentItemWithImageProps[];
  };
  groupRight: {
    title?: string | undefined;
    posts: ContentItemWithImageProps[];
  };
};

export type VerticalContentTypes =
  | GroupOf3Type
  | FourColumnType
  | GridComponentType;

const isContentBlockWithACF = (
  contentBlock: VerticalContentTypes,
  fieldName: string
): boolean =>
  typeof contentBlock === "object" &&
  "layoutStyle" in contentBlock &&
  contentBlock.layoutStyle === fieldName;

export const isGroupOf3ContentBlock = (
  contentBlock: VerticalContentTypes
): contentBlock is GroupOf3Type =>
  isContentBlockWithACF(contentBlock, "groupOf3");

export const isFourColumnContentBlock = (
  contentBlock: VerticalContentTypes
): contentBlock is FourColumnType =>
  isContentBlockWithACF(contentBlock, "fourColumn");

export const isGridComponentContentBlock = (
  contentBlock: VerticalContentTypes
): contentBlock is GridComponentType =>
  isContentBlockWithACF(contentBlock, "grid");
